import { render, staticRenderFns } from "./Boat.vue?vue&type=template&id=024ff308&"
import script from "./Boat.vue?vue&type=script&lang=js&"
export * from "./Boat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Boat.vue"
export default component.exports